// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"798":"css/app.6779","7958":"css/admin-app.6779"}[chunkId] + ".css";
};